import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { mutate } from "lib/graphql/mutate"

export const setAllTypeReviews = api(async function setAllTypeReviews({ id, reviewStatus }) {
    return mutate(
        gql`
            mutation SetAllTypeReviews($id: String!, $reviewStatus: ReviewStatus!) {
                setAllTypeReviews(id: $id, reviewStatus: $reviewStatus)
            }
        `,
        { id, reviewStatus },
        { returns: "setAllTypeReviews" }
    )
})
